<template>
    <div class="col-12 col-md-4 card-wrapper">
        <div class="card">
            <div class="card-header" @click="getVideoList" :style="headerStyle()">
                <div class="icon">
                     <design-2021-apprentice-inline-svg-component :icon-source="showDomain.icon" color="#fff"></design-2021-apprentice-inline-svg-component>
                </div>
                {{showDomain.name}}
            </div>
            <div class="card-body" v-if="domainWithSubs.subDomains">
                <p class="card-title" v-for="subdomain in domainWithSubs.subDomains" :key="subdomain.name"
                   @click="getSubDomainList(subdomain)"
                   :style="titleStyle(subdomain.hover)"
                   @mouseover="subdomain.hover = true"
                   @mouseleave="subdomain.hover = false"
                >
                    {{subdomain.name}}</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "design-2021-digitalstudies-subject-card",
        props: {
            showDomain: Object,
            required: true,
        },
        data() {
            return {
                domainWithSubs: this.showDomain,
                subDomains: {}

            }
        },
        created() {
            this.subDomains = this.showDomain.subDomains.map(subdomain => {
                return {
                    ...subdomain,
                    hover: false
                }
            });
            this.domainWithSubs.subDomains = this.subDomains
        },
        methods: {
            getVideoList(){
                window.location.href = baseUrl+'/videos/video/domain/'+this.showDomain.id;
            },
            getSubDomainList(subDomain){
                window.location.href = baseUrl+'/videos/video/domain/'+this.showDomain.id+'?sub_domain_id='+subDomain.id;
            },
            makeHachTags(rawText){
                let cleanText = rawText.replace(/[^0-9]+/g, '');
                cleanText = rawText.replace(/[^A-Za-z]+/g,"-");
                return cleanText.substr(1).toLowerCase();
            },
            headerStyle() {
                return {
                    'background-color': this.showDomain.color
                }
            },
            titleStyle(hoverState){
               if(hoverState) return {
                    'background-color': this.showDomain.color,
                    'color': '#fff'
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .card-wrapper {
        margin-bottom: 30px;
    }

    .card{
        height: 100%;
    }

    .card-header,
    .card-title {
        cursor: pointer;
    }

    .card-header {
        padding: 11px;
        color: $white;
        font-size: $default-font-size;
        font-weight: $font-weight-bold;
    }

    .card-title{
        font-size: $default-font-size;
        font-weight: $font-weight-normal;
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
        padding: 7px;
    }

    .card-body {
        padding: map-get($grid-gutter-spacing, 'twenty-one') map-get($grid-gutter-spacing, 'fifteen');
    }

    .icon {
        display: inline-block;
        height: 30px;
        width: 30px;
        margin-right: map-get($grid-gutter-spacing, 'ten');
    }

    .icon > svg {
        max-height: 30px;
    }

</style>
